import './App.scss';
import { Header } from './components/moleculas/header/Header';
import { InputForm } from './components/moleculas/inputform/InputForm2';
import { MultiForm } from './components/moleculas/multiform/Multiform';
import Dashboard from './components/organisms/dashboard/Dashboard';
import { DataProvider } from './components/organisms/dashboard/context/DataContext';

function App() {
  const modelName = process.env.REACT_APP_MODEL_NAME;

  let content;

  switch (modelName) {
    case 'meet_pneumatics':
      content = (
        <>
          <Header modelName={modelName} />
          <MultiForm modelName={modelName} />
        </>
      );
      break;
    case 'ami_dashboard':
      content = (
        <DataProvider>
          <Dashboard />
        </DataProvider>
      );
      break;
    default:
      content = (
        <>
          <Header modelName={modelName ?? ''} />
          <InputForm modelName={modelName ?? ''} />
        </>
      );
      break;
  }

  return <>{modelName ? <>{content}</> : <p>Incorrect model name</p>}</>;
}

export default App;
